import { useDialog } from '@dni-hooks/useDialog'
import { type CheckoutOrder } from '@hooks-api/types/dataModel/orders'
import { Button } from '@pets-ui/Button/Button'
import { ArrowRightSmall } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { fieldRefHelper } from '@utils/fieldRefHelper'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { CardSection } from '../../../../../components/CardSection/CardSection'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { DIALOG_MERCHANT_INFO, DialogMerchantInfo } from './DialogMerchantInfo'

const styles = stylex.create({
  info: {
    borderColor: colors.grey300,
    justifyContent: 'flex-start',
    paddingRight: 36,
    width: '100%',
  },
  infoError: {
    borderColor: colors.red600,
  },
  disabled: {
    backgroundColor: colors.grey200,
  },
  endIcon: {
    position: 'absolute',
    right: 16,
  },
})

export function MerchantInfo() {
  const { isInRetryPaymentPage } = useCheckout()
  const { control } = useFormContext<CheckoutOrder>()
  const [firstName, email, phone] = useWatch({ control, name: ['billing_address_first_name', 'billing_address_email', 'billing_address_phone'] })
  const { openDialog } = useDialog(DIALOG_MERCHANT_INFO)
  const conditions = [
    !firstName,
    !email,
    !phone,
  ]
  const isAllInfoEmpty = conditions.every(Boolean)
  const isError = conditions.some(Boolean)
  return (
    <>
      <Controller
        control={control}
        name="merchantInfoValidation"
        rules={{ validate: () => !isError || '此為必填欄位' }}
        render={({ field: { ref }, fieldState: { error } }) => {
          return (
            <VStack rootRef={fieldRefHelper(ref)}>
              <CardSection title="經銷商資訊">
                <Button
                  variant="outlined"
                  color="grey"
                  endIcon={<ArrowRightSmall />}
                  rootStyle={[styles.info, isInRetryPaymentPage && styles.disabled, error && styles.infoError]}
                  xStyles={{
                    endIcon: styles.endIcon,
                  }}
                  onClick={openDialog}
                  disabled={isInRetryPaymentPage}
                >
                  {isAllInfoEmpty
                    ? (
                      <Text variant="body" color={colors.grey500}>
                        目前尚無任何資訊
                      </Text>
                    )
                    : (
                      <VStack>
                        <Text variant="subtitle" color={isInRetryPaymentPage ? colors.grey500 : colors.black}>
                          {firstName || '-'}
                        </Text>
                        <Text variant="body" color={isInRetryPaymentPage ? colors.grey500 : colors.black}>
                          {email || '-'}
                        </Text>
                        <Text variant="body" color={isInRetryPaymentPage ? colors.grey500 : colors.black}>
                          {phone || '-'}
                        </Text>
                      </VStack>
                    )}
                </Button>
                {error && (<Text color={colors.red600}>{error.message}</Text>)}
              </CardSection>
            </VStack>
          )
        }}
      />
      <DialogMerchantInfo />
    </>
  )
}
